// Device-side registry of native recordings whose encounter is confirmed GONE
// (deleted server-side). The native app NEVER abandons an "error" recording —
// it re-offers it to the WebView forever with capped backoff
// (lucasai-app Recorder.syncRecordings, "Never abandon") and the
// recordingUpdate bridge has no field to mark a row non-retryable from here.
// So the WebView remembers confirmed-orphaned recordings itself and answers
// each re-offer instantly ("error", audio kept) with NO API call, NO toast,
// and NO error report — killing the infinite 404 + support-email loop while
// the audio stays on the device (visible and deletable in the app's
// Recordings screen).
//
// Entries are keyed to the brain (org): the same chatId 404s when the user is
// merely logged into ANOTHER org, so a poison mark from one org must never
// suppress a real retry after they log back into the right one. Entries
// expire after 90 days and the list is capped — localStorage is per-device
// and self-healing (worst case after eviction/expiry: one extra confirmed-404
// round trip re-poisons the entry).

// Storage machinery (TTL expiry, entry cap, guarded localStorage) is the shared
// createBoundedTtlStore — the same one offlineDiffPoisonRegistry uses. Only the
// entry shape and the questions asked of it live here.
import { createBoundedTtlStore } from "./boundedTtlStore";

const store = createBoundedTtlStore({
  key: "recordingDrainPoison.v1",
  ttlMs: 90 * 24 * 60 * 60 * 1000,
  maxEntries: 300,
});

export function isPoisonedRecording(recordingKey, brainId) {
  if (recordingKey == null || brainId == null) return false;
  const k = String(recordingKey);
  const b = String(brainId);
  return store.load().some((e) => e.k === k && e.b === b);
}

export function poisonRecording(recordingKey, brainId) {
  if (recordingKey == null || brainId == null) return;
  const k = String(recordingKey);
  const b = String(brainId);
  const list = store.load().filter((e) => !(e.k === k && e.b === b));
  list.push({ k, b, ts: Date.now() });
  store.save(list);
}

// Test helper.
export function clearPoisonRegistry() {
  store.clear();
}
